import React, { useReducer, useState } from "react";
import { Box, FormControl, FormHelperText, Icon } from "@mui/material";
import Grid from "@mui/material/Grid2";
import MaterialInput from "../../../../components/MaterialInput";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import VisibilityIcon from "@mui/icons-material/Visibility";
import MaterialButton from "../../../../components/MaterialButton";
import MaterialBox from "../../../../components/MaterialBox";
import { useNavigate } from "react-router-dom";
import { signInState, signInStateMange, userLogin } from "./signData";
import request from "graphql-request";
import BASEURL from "../../../../pages/Utils/Baseurl";
import { useLoading } from "../../../../context/LodingContext";
import Swal from "sweetalert2";
import { useLocalStorage } from "../../../hooks/useLocalStorage";
import { useEffect } from "react";
import { useAuthData } from "../../../context/loginContext/LoginContextProvider";
import routes from "../../../../routes";
import URL from "../../../../pages/Utils/url";

const SignInputField = () => {
  const [signInData, dispatch] = useReducer(signInStateMange, signInState);
  const [viewPassword, setViewPassword] = useState(false);
  const {
    setAuthenticated,

    setUserID,
    setAccess,

    setUserImage,

    setUserDetails,
  } = useAuthData();
  const { setCirleLoading } = useLoading();
  const { setItem } = useLocalStorage("access");
  const navigate = useNavigate();
  const handlePasswordVisibility = () => {
    setViewPassword(!viewPassword);
  };
  useEffect(() => {
    setAuthenticated(false);
    localStorage.clear();
    sessionStorage.clear();
  }, []);

  const keydownHandler = (event) => {
    if (
      event.key == "Enter" &&
      signInData.emailStatus === "success" &&
      signInData.passwordStatus === "success"
    ) {
      handleSignIn();
    }
  };

  const handleSignIn = async () => {
    setCirleLoading(true);
    try {
      const res = await request(BASEURL, userLogin, {
        email: signInData?.email,

        password: signInData?.password,
      });

      const userDetails = await res?.userLogin;
      const webuse = await res?.userLogin?.webUse;
      const success = await res?.userLogin?.success;
      const message = await res?.userLogin?.message;
      const user_id = await res?.userLogin?.id;
      const access = await res?.userLogin?.access;
      const image = (await res?.userLogin?.image)
        ? `${URL}media/${res?.userLogin?.image}`
        : null;
      setUserDetails(userDetails);
      setUserImage(image);
      // Step 1: get module names from role access array
      const accessibleModules =
        access?.filter((item) => item.can_access).map((item) => item.module) ||
        [];

      // Step 2: Find the first route in the routes array that matches an accessible module
      let routeToNavigate = null;

      // Iterate over the routes array
      for (let route of routes) {
        // Check if the module of the current route is in the accessibleModules
        if (accessibleModules.includes(route.module)) {
          if (route.collapse && route.collapse.length > 0) {
            // Look for the first accessible collapse route
            const accessibleCollapseRoute = route.collapse.find(
              (collapseRoute) =>
                accessibleModules.includes(collapseRoute.module) &&
                collapseRoute.protected === true
            );

            // If an accessible collapse route is found, navigate to it
            if (accessibleCollapseRoute) {
              routeToNavigate = accessibleCollapseRoute.route;
              break;
            }
          }

          // If no collapse route was found, navigate to the top-level route
          if (!routeToNavigate) {
            routeToNavigate = route.route;
            break;
          }
        }
      }

      setUserID(user_id);
      setAccess(access);
      setItem(access);
      localStorage.setItem("userID", JSON.stringify(user_id));
      localStorage.setItem("userImage", JSON.stringify(image));
      localStorage.setItem("userDetails", JSON.stringify(userDetails));
      localStorage.setItem("refresh", true);
      if (success) {
        if (webuse) {
          Swal.fire({
            position: "top",
            icon: "success",
            title: message,
            showConfirmButton: false,
            timer: 2000,
            didOpen: () => {
              document.querySelector(".swal2-popup").style.zIndex =
                "999999999999999";
            },
          }).then(() => {
            localStorage.setItem("loginStatus", true);
            setAuthenticated(true);
            // Step 3: Navigate to the first matched route else default /dashboard
            if (routeToNavigate) {
              // navigate(routeToNavigate);
              navigate("/dashboard");
            } else {
              navigate("/dashboard");
            }
          });
        } else {
          Swal.fire({
            position: "top",
            icon: "error",
            title: "Web not use this person",
            showConfirmButton: true,
            didOpen: () => {
              document.querySelector(".swal2-popup").style.zIndex =
                "999999999999999";
            },
          });
        }
      } else {
        Swal.fire({
          position: "top",
          icon: "error",
          title: message,
          showConfirmButton: true,
          didOpen: () => {
            document.querySelector(".swal2-popup").style.zIndex =
              "999999999999999";
          },
        });
      }
    } catch (err) {
    } finally {
      setCirleLoading(false);
    }
  };
  const checkAllFields = () => {
    let allowSubmit = false;
    if (
      signInData.emailStatus === "success" &&
      signInData.passwordStatus === "success"
    ) {
      allowSubmit = true;
    } else {
      allowSubmit = false;
    }
    return allowSubmit;
  };
  return (
    <div>
      <Grid container spacing={4}>
        <Grid size={{ xs: 12, sm: 12 }} sx={{ position: "relative" }}>
          <MaterialInput
            fullWidth
            onKeyDown={keydownHandler}
            placeholder="Email"
            name="email"
            variant="outlined"
            value={signInData.email}
            onChange={(e) =>
              dispatch({ value: e?.target?.value, name: "email" })
            }
            error={signInData.emailStatus === "error" ? true : false}
            success={signInData.emailStatus === "success" ? true : false}
          />
          {signInData.emailStatus === "error" ? (
            <FormControl
              sx={{ position: "absolute", bottom: "-17px", zIndex: "10px" }}
              error
            >
              <FormHelperText>Please enter valid email address</FormHelperText>
            </FormControl>
          ) : null}
        </Grid>
        <Grid size={{ xs: 12, sm: 12 }} sx={{ position: "relative" }}>
          <MaterialInput
            fullWidth
            onKeyDown={keydownHandler}
            placeholder="Password"
            name="password"
            type={viewPassword ? "text" : "password"}
            variant="outlined"
            value={signInData.password}
            onChange={(e) =>
              dispatch({ value: e?.target?.value, name: "password" })
            }
            error={signInData.passwordStatus === "error" ? true : false}
            success={signInData.passwordStatus === "success" ? true : false}
            icon={
              viewPassword
                ? {
                    direction: "right",
                    component: (
                      <Icon color="#2a9941" fontSize="small">
                        <VisibilityIcon
                          onClick={handlePasswordVisibility}
                          style={{ cursor: "pointer" }}
                        />
                      </Icon>
                    ),
                  }
                : {
                    direction: "right",
                    component: (
                      <Icon color="#2a9941" fontSize="small">
                        <VisibilityOffIcon
                          onClick={handlePasswordVisibility}
                          style={{ cursor: "pointer" }}
                        />
                      </Icon>
                    ),
                  }
            }
          />
          {signInData.passwordStatus === "error" ? (
            <FormControl
              sx={{ position: "absolute", bottom: "-33px", zIndex: "10px" }}
              error
            >
              <FormHelperText>
                Your password must be min 8 and max 15 characters.
              </FormHelperText>
            </FormControl>
          ) : null}
        </Grid>
      </Grid>

      <Box sx={{ padding: "15px 0px" }}>
        <MaterialBox display="flex" justifyContent="flex-end" my={2}>
          <MaterialButton
            variant="text"
            color="primary"
            onClick={() => {
              navigate("/sign-in/forgotemail");
            }}
            sx={{ padding: 0 }}
            // disabled={signInData.emailStatus === "success" ? false : true}
          >
            Forgot Password ?
          </MaterialButton>
        </MaterialBox>
        <MaterialButton
          onClick={handleSignIn}
          variant="contained"
          color="primary"
          fullWidth
          disabled={!checkAllFields()}
        >
          Sign in
        </MaterialButton>
      </Box>
    </div>
  );
};

export default SignInputField;
